/** Compact determinate progress bar for table cells and summary rows.
 *  Brand-royal fill while in progress, positive tone once complete —
 *  matching the status-color contract (green = done, blue = queued
 *  work). Renders an accessible progressbar with the fraction label. */
export function ProgressBar({
  done,
  total,
  className,
  fullWidth,
}: {
  done: number;
  total: number;
  className?: string;
  /** Stretch the track to the container (wizard headers) instead of the
   *  compact fixed-width table-cell form. */
  fullWidth?: boolean;
}) {
  const complete = total > 0 && done >= total;
  const percent = total > 0 ? Math.round((Math.min(done, total) / total) * 100) : 0;
  return (
    <div className={`flex items-center gap-2 ${className ?? ''}`}>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={Math.min(done, total)}
        aria-label={`${done} of ${total} steps complete`}
        className={`h-1.5 overflow-hidden rounded-full bg-border ${fullWidth ? 'flex-1' : 'w-20'}`}
      >
        <div
          className={`h-full rounded-full transition-[width] ${
            complete ? 'bg-emerald-600' : 'bg-brand-royal'
          }`}
          style={{ width: `${percent}%` }}
        />
      </div>
      <span className="font-mono text-xs tabular-nums text-brand-slate">
        {done}/{total}
      </span>
    </div>
  );
}
